// @flow
export default {
  "111": "ark",
  "0": "bitcoin", // Bitcoin mainnet
  "1": "bitcoin", // Bitcoin testnet
  "145": "bitcoin", // Bitcoin Cash
  "156": "bitcoin", // Bitcoin Gold
  "79": "clubcoin",
  "5": "dash",
  "42": "decred",
  "20": "digibyte",
  "3": "dogecoin",
  "61": "ethereumClassic",
  "40": "expanse",
  "171": "hcash",
  "141": "komodo",
  "2": "litecoin",
  "128": "monero",
  "888": "neo",
  "6": "peercoin",
  "119": "pivx",
  "47": "posw",
  "2301": "qtum",
  "144": "ripple",
  "125": "stealthcoin",
  "148": "stellar",
  "105": "stratis",
  "108": "ubiq",
  "28": "vertcoin",
  "14": "viacoin",
  "133": "zcash"
};
